import { regex } from '@entries/contentful-subscription-form/regex'
import {
  AccountType,
  Civility,
  Country,
} from '@entries/contentful-subscription-form/types'
import { validationErrorMessage } from '@entries/contentful-subscription-form/validation-error.messages'
import { object, string } from 'yup'

const { REGEX_DATE, REGEX_NAME, REGEX_EMAIL, REGEX_PHONE, REGEX_POSTALCODE } =
  regex

const getMinimalDateAllowed = () => {
  const currentDate = new Date().toDateString()
  const minimalDateAllowed = new Date(currentDate)
  return minimalDateAllowed.setFullYear(minimalDateAllowed.getFullYear() - 100)
}

const getMaximalFateAllowed = () => {
  const currentDate = new Date().toDateString()
  const maxDateAllowed = new Date(currentDate)
  return maxDateAllowed.setFullYear(maxDateAllowed.getFullYear() - 18)
}

export const validationSchema = object({
  lastName: string()
    .required(validationErrorMessage.EMPTY_LASTNAME)
    .max(32, validationErrorMessage.MAX_32_CHAR)
    .matches(REGEX_NAME, validationErrorMessage.INVALID_FORMAT),
  firstName: string()
    .required(validationErrorMessage.EMPTY_FIRSTNAME)
    .max(32, validationErrorMessage.MAX_32_CHAR)
    .matches(REGEX_NAME, validationErrorMessage.INVALID_FORMAT),
  birthDate: string()
    .required(validationErrorMessage.EMPTY_BIRTHDATE)
    .test('max-allowed', validationErrorMessage.MINOR, (value) => {
      const parts = value.split('/')
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const year = parseInt(parts[2], 10)
      const date = new Date(year, month, day)

      return value ? date.getTime() < getMaximalFateAllowed() : false
    })
    .test('min-allowed', validationErrorMessage.INVALID_DATE, (value) => {
      const parts = value.split('/')
      const day = parseInt(parts[0], 10)
      const month = parseInt(parts[1], 10) - 1
      const year = parseInt(parts[2], 10)
      const date = new Date(year, month, day)
      if (
        date.getDate() !== day ||
        date.getMonth() !== month ||
        date.getFullYear() !== year
      ) {
        return false
      }

      return date.getTime() > getMinimalDateAllowed()
    })
    .matches(REGEX_DATE, validationErrorMessage.INVALID_DATE),
  country: string()
    .required(validationErrorMessage.ONLY_METROPOLITAN_FRANCE)
    .oneOf([Country.DEFAULT], validationErrorMessage.ONLY_METROPOLITAN_FRANCE),
  postalCode: string()
    .required(validationErrorMessage.EMPTY_POSTALCODE)
    .min(5, validationErrorMessage.INVALID_POSTALCODE_FORMAT)
    .max(5, validationErrorMessage.INVALID_POSTALCODE_FORMAT)
    .matches(REGEX_POSTALCODE, validationErrorMessage.INVALID_FORMAT),
  email: string()
    .required(validationErrorMessage.EMPTY_EMAIL)
    .max(50, validationErrorMessage.MAX_50_CHAR)
    .matches(REGEX_EMAIL, validationErrorMessage.INVALID_FORMAT),
  tel: string()
    .required(validationErrorMessage.EMPTY_PHONE)
    .min(10, validationErrorMessage.INVALID_PHONE)
    .max(10, validationErrorMessage.INVALID_PHONE)
    .matches(REGEX_PHONE, validationErrorMessage.INVALID_PHONE),
  civility: string()
    .required(validationErrorMessage.INVALID_CIVILITY)
    .oneOf(
      [Civility.MONSIEUR, Civility.MADAME],
      validationErrorMessage.INVALID_CIVILITY
    ),
  accountType: string()
    .required(validationErrorMessage.INVALID_ACCOUNT_TYPE)
    .oneOf(
      [AccountType.INDIVIDUAL, AccountType.JOINT],
      validationErrorMessage.INVALID_ACCOUNT_TYPE
    ),
})
